import React from 'react';

//components
import GoogleReviews from './GoogleReviews';
import {useIsHydrated} from '~/hooks/useIsHydrated';

/**
 * Homepage social-proof band: Google shop reviews only.
 *
 * The Loox carousel that used to sit alongside was dropped by request —
 * one first-party source of truth (the shop's Google rating and its 4-5
 * star reviews via routes/($lang)/api/google-reviews) instead of a
 * third-party iframe.
 *
 * Gated on hydration because the widget fetches client-side; it hides
 * itself when the API has nothing to show, so the band collapses cleanly.
 */
export default function HomeReviews() {
  const isHydrated = useIsHydrated();
  if (!isHydrated) return <></>;

  return (
    <section className="bg-hk-gray py-14">
      <header className="mb-8 text-center">
        <h2 className="text-xl md:text-section font-bold uppercase tracking-wide">顧客評價</h2>
      </header>
      <GoogleReviews />
    </section>
  );
}
